import { useTranslation } from 'react-i18next';
import { ClipboardList, Key } from 'lucide-react';

import PageHeader from '@components/layout/page-header';
import Tabs, { Tab } from '@components/atoms/ui-kit/tabs';
import LicenseRequestsTab from '@components/back-office/licensing/license-requests-tab';
import LicenseKeysTab from '@components/back-office/licensing/license-keys-tab';
import { useThemeContext } from '@utils/hooks/use-theme-context';

export default function LicensingBo() {
  const { t } = useTranslation();
  const { getColour } = useThemeContext();

  const tabs: Tab[] = [
    {
      id: 0,
      name: (
        <span className="flex items-center gap-2">
          <ClipboardList className="h-4 w-4" />
          {t('license-requests')}
        </span>
      ),
      component: <LicenseRequestsTab />
    },
    {
      id: 1,
      name: (
        <span className="flex items-center gap-2">
          <Key className="h-4 w-4" />
          {t('license-keys')}
        </span>
      ),
      component: <LicenseKeysTab />
    }
  ];

  return (
    <div className="bg-app flex-1 min-h-0 flex flex-col gap-y-4">
      <PageHeader
        title={t('licensing')}
        caption={t('manage-on-prem-license-requests-and-keys')}
      />

      {/* Info Card */}
      <div className="rounded-2xl border border-hairline bg-app-soft shadow-card p-4">
        <p className="text-sm" style={{ color: getColour('normalText') }}>
          {t('licensing-overview-description')}
        </p>
        <div className="mt-3 grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div className="flex items-start gap-3">
            <div className="p-2 rounded-2xl border border-hairline bg-app">
              <ClipboardList
                className="h-5 w-5"
                style={{ color: getColour('activeText') }}
              />
            </div>
            <div>
              <p
                className="text-sm font-medium"
                style={{ color: getColour('normalText') }}
              >
                {t('license-requests')}
              </p>
              <p
                className="text-xs mt-0.5"
                style={{ color: getColour('inactiveText') }}
              >
                {t('license-requests-description')}
              </p>
            </div>
          </div>
          <div className="flex items-start gap-3">
            <div className="p-2 rounded-2xl border border-hairline bg-app">
              <Key
                className="h-5 w-5"
                style={{ color: getColour('activeText') }}
              />
            </div>
            <div>
              <p
                className="text-sm font-medium"
                style={{ color: getColour('normalText') }}
              >
                {t('license-keys')}
              </p>
              <p
                className="text-xs mt-0.5"
                style={{ color: getColour('inactiveText') }}
              >
                {t('license-keys-description')}
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Tabs Card */}
      <div className="flex-1 min-h-0 rounded-2xl border border-hairline bg-app-soft shadow-card p-4">
        <Tabs tabs={tabs} searchParams minHeight="0" maxHeight="100%" />
      </div>
    </div>
  );
}
